
// FilterSidebar.tsx
import React from 'react';
import { Card, CardHeader, CardContent, CardTitle, CardDescription } from '@/components/ui/card';
import { Filter, ChevronLeft, ChevronDown } from 'lucide-react';
import { Skeleton } from '@/components/ui/skeleton';
import DataFilters from './DataFilters';
import type { DashboardStats, UniqueFilterValues } from '@/hooks/useUnifiedDashboardData';
import { PropertyFilters } from '@/types/property';
import { Button } from '@/components/ui/button';

interface FilterSidebarProps {
  loading: boolean;
  dataLoaded: boolean;
  uniqueValues: UniqueFilterValues;
  stats: DashboardStats;
  filteredStats?: DashboardStats;
  applyFilters: (filters: PropertyFilters) => void;
  isExpanded: boolean;
  onToggleExpand: () => void;
  isMobile?: boolean;
  filters: PropertyFilters;
  setFilters: React.Dispatch<React.SetStateAction<PropertyFilters>>;
  bairroSearch: string;
  setBairroSearch: React.Dispatch<React.SetStateAction<string>>;
  tipoSearch: string;
  setTipoSearch: React.Dispatch<React.SetStateAction<string>>;
  clearFilters: () => void;
}

const FilterSidebar: React.FC<FilterSidebarProps> = ({
  loading,
  dataLoaded,
  uniqueValues,
  stats,
  filteredStats,
  applyFilters,
  isExpanded,
  onToggleExpand,
  isMobile = false,
  filters,
  setFilters,
  bairroSearch,
  setBairroSearch,
  tipoSearch,
  setTipoSearch,
  clearFilters,
}) => {
  return (
    <Card className="h-full">
      <CardHeader className="pb-2">
        <div className="flex items-center justify-between">
          <CardTitle className="flex items-center gap-2 text-base md:text-lg">
            <Filter className="h-4 w-4 md:h-5 md:w-5" />
            Filtros
          </CardTitle>
          <Button
            variant="ghost"
            size="sm"
            onClick={onToggleExpand}
            className="h-7 w-7 md:h-8 md:w-8 p-0"
          >
            {isMobile ? (
              <ChevronDown className="h-4 w-4" />
            ) : (
              <ChevronLeft className="h-4 w-4" />
            )}
            <span className="sr-only">
              {isMobile ? 'Fechar filtros' : 'Recolher filtros'}
            </span>
          </Button>
        </div>
        <CardDescription className="text-xs md:text-sm">
          Refine a visualização dos dados
        </CardDescription>
      </CardHeader>
      <CardContent>
        {loading && !dataLoaded ? (
          <div className="space-y-2">
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-full" />
          </div>
        ) : (
          <DataFilters
            uniqueValues={uniqueValues}
            applyFilters={applyFilters}
            stats={stats}
            filteredStats={filteredStats || stats}
            isMobile={isMobile}
            filters={filters}
            setFilters={setFilters}
            bairroSearch={bairroSearch}
            setBairroSearch={setBairroSearch}
            tipoSearch={tipoSearch}
            setTipoSearch={setTipoSearch}
            clearFilters={clearFilters}
          />
        )}
      </CardContent>
    </Card>
  );
};

export default FilterSidebar;
